// removed by extract-text-webpack-plugin
module.exports = {"Base":"Navigation__Base-3eYMn","Item":"Navigation__Item-Eszcu","Item--withDivider":"Navigation__Item--withDivider-9o74n","NavLeft":"Navigation__NavLeft-Aqfm-","NavRight":"Navigation__NavRight-2Pzl2","SupportMessage":"Navigation__SupportMessage-3sPqs","SocialNav":"Navigation__SocialNav-3GT-D","SocialLinks":"Navigation__SocialLinks-6QWFd","SocialLinks--facebook":"Navigation__SocialLinks--facebook-2wSPJ","SocialLinks--twitter":"Navigation__SocialLinks--twitter-1nsIN","SearchNav":"Navigation__SearchNav-2DlOr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Navigation/Navigation.css
 ** module id = 636
 ** module chunks = 0
 **/